const maxLengthJoin = (array: string[] | number[]) =>
  // 150 byte requirement
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#customs
  // presuming UTF-8 characters where each char is one byte
  array.join(', ').substring(0, 150);

export default maxLengthJoin;
